var map = {
	"./de/general11/slide2.svg": 322652,
	"./en/general11/slide2.svg": 21808,
	"./es/general11/slide2.svg": 51003,
	"./fr/general11/slide2.svg": 194243,
	"./nl/general11/slide2.svg": 907389,
	"./pt/general11/slide2.svg": 951607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 995662;